export const LIST_NUMBER_ANALYZE = 'LIST_NUMBER_ANALYZE';
export const FETCH_NUMBER_ANALYZE = 'FETCH_NUMBER_ANALYZE';
export const CLEAR_NUMBER_ANALYZE = 'CLEAR_NUMBER_ANALYZE';

export const LIST_NUMBER_FILTER = 'LIST_NUMBER_FILTER';
export const FETCH_NUMBER_FILTER = 'FETCH_NUMBER_FILTER';
export const CLEAR_NUMBER_FILTER = 'CLEAR_NUMBER_FILTER';


export const LIST_NUMBER_MANAGE = 'LIST_NUMBER_MANAGE';
export const FETCH_NUMBER_MANAGE = 'FETCH_NUMBER_MANAGE';
export const CLEAR_NUMBER_MANAGE = 'CLEAR_NUMBER_MANAGE';

